// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Reusable pieces: buttons, chips, cards, nav, palette, cursor
------------------------------------------------------------------- */

/* ---------- Buttons ---------- */
.btn {
  --btn-bg: var(--surface-strong);
  --btn-fg: var(--text);
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.78rem 1.35rem;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--btn-bg);
  color: var(--btn-fg);
  font-weight: 600;
  font-size: var(--step-0);
  letter-spacing: -0.01em;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.24s var(--ease), border-color 0.24s var(--ease),
    background-color 0.24s var(--ease), box-shadow 0.24s var(--ease), color 0.24s var(--ease);
}
.btn:hover { transform: translateY(-2px); border-color: var(--line-strong); }
.btn:active { transform: translateY(0); }
.btn svg { flex: none; }

.btn--primary {
  --btn-bg: var(--accent);
  --btn-fg: var(--accent-ink);
  border-color: var(--accent);
}
.btn--primary:hover {
  --btn-bg: var(--accent-hover);
  border-color: var(--accent-hover);
}

.btn--ghost:hover { background: var(--surface-hover); }
.btn--sm { padding: 0.5rem 0.95rem; font-size: var(--step--1); }
.btn--block { width: 100%; }
.btn[disabled] { opacity: 0.5; pointer-events: none; }

/* ---------- Chips / tags ---------- */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 0.42rem;
  padding: 0.28rem 0.62rem;
  border-radius: var(--r-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-soft);
  max-width: 100%;
  overflow-wrap: anywhere;
  transition: color 0.2s var(--ease), border-color 0.2s var(--ease), background-color 0.2s var(--ease);
}
.chip:hover { color: var(--text); border-color: var(--line-strong); }
.chip--accent { color: var(--accent); border-color: color-mix(in srgb, var(--accent) 35%, transparent); }

.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* ---------- Card ---------- */
.card {
  position: relative;
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  background: var(--surface);
  overflow: hidden;
  transition: border-color 0.3s var(--ease), transform 0.3s var(--ease), box-shadow 0.3s var(--ease);
}
.card:hover { border-color: var(--line-strong); }

/* Pointer-tracked spotlight. Position comes from CSS vars set on rAF. */
.card--spot:hover { background: var(--surface-strong); }

/* Tilt toward the pointer. The parent supplies the perspective so the
   transform stays a single composited property on the card itself. */
.card--tilt {
  transform: perspective(1100px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg));
  transform-style: preserve-3d;
  transition: transform 0.5s var(--ease), border-color 0.3s var(--ease);
}
.card--tilt:hover { transition-duration: 0.12s; }
@media (prefers-reduced-motion: reduce), (hover: none) {
  .card--tilt { transform: none; }
}

.card__body { padding: clamp(1.15rem, 0.9rem + 0.8vw, 1.75rem); }

/* ---------- Nav ---------- */
.nav {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 60;
  height: var(--nav-h);
  display: flex;
  align-items: center;
  transition: background-color 0.3s var(--ease), border-color 0.3s var(--ease);
  border-bottom: 1px solid transparent;
}
.nav[data-stuck="true"] {
  background: color-mix(in srgb, var(--bg) 88%, transparent);
  border-bottom-color: var(--line);
}
.nav__inner {
  width: 100%;
  max-width: var(--maxw);
  margin-inline: auto;
  padding-inline: var(--gutter);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-right: auto;
}
.brand__mark {
  width: 34px; height: 34px;
  border-radius: var(--r-sm);
  display: grid;
  place-items: center;
  background: var(--accent);
  color: var(--accent-ink);
  font-family: var(--font-mono);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  transition: background-color 0.25s var(--ease);
}
.brand:hover .brand__mark { background: var(--accent-hover); }
.brand__text { font-size: 1rem; }
.brand__text small {
  display: block;
  font-family: var(--font-mono);
  font-size: 0.62rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--text-dim);
  font-weight: 500;
}

.nav__links {
  display: flex;
  align-items: center;
  gap: 0.15rem;
}
.nav__link {
  position: relative;
  padding: 0.5rem 0.85rem;
  border-radius: var(--r-pill);
  font-size: var(--step--1);
  font-weight: 500;
  color: var(--text-soft);
  transition: color 0.2s var(--ease), background-color 0.2s var(--ease);
}
.nav__link:hover { color: var(--text); background: var(--surface); }
.nav__link[aria-current="page"] { color: var(--text); }
.nav__link[aria-current="page"]::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 2px;
  width: 16px;
  height: 2px;
  transform: translateX(-50%);
  background: var(--accent);
}

.nav__tools {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.icon-btn {
  width: 38px; height: 38px;
  display: grid;
  place-items: center;
  border-radius: var(--r-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--text-soft);
  transition: color 0.22s var(--ease), background-color 0.22s var(--ease),
    border-color 0.22s var(--ease), transform 0.22s var(--ease);
}
.icon-btn:hover {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--line-strong);
  transform: translateY(-2px);
}

.kbd-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 38px;
  padding-inline: 0.7rem;
  border-radius: var(--r-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--text-dim);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  transition: color 0.22s var(--ease), border-color 0.22s var(--ease), background-color 0.22s var(--ease);
}
.kbd-btn:hover { color: var(--text); border-color: var(--line-strong); background: var(--surface-hover); }

kbd {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  padding: 0.12rem 0.36rem;
  border-radius: 5px;
  border: 1px solid var(--line-strong);
  background: var(--surface-strong);
  color: var(--text-soft);
  line-height: 1.5;
}

.nav__burger { display: none; }

@media (max-width: 900px) {
  .nav__links, .kbd-btn { display: none; }
  .nav__burger { display: grid; }
}

/* Mobile drawer */
.drawer {
  position: fixed;
  inset: var(--nav-h) 0 0 0;
  z-index: 55;
  background: var(--bg);
  padding: 1.6rem var(--gutter) 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  animation: drawerIn 0.32s var(--ease);
  overflow-y: auto;
}
@keyframes drawerIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: none; }
}
.drawer__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.25rem;
  font-size: var(--step-2);
  font-weight: 600;
  border-bottom: 1px solid var(--line);
  color: var(--text-soft);
}
.drawer__link[aria-current="page"] { color: var(--accent); }
.drawer__link span { font-family: var(--font-mono); font-size: 0.7rem; color: var(--text-dim); }

.drawer__foot { margin-top: auto; padding-top: 2rem; }
.drawer__foot .socials { margin-top: 0.7rem; }

/* ---------- Scroll progress ---------- */
.progress {
  position: fixed;
  top: 0; left: 0;
  z-index: 70;
  height: 2px;
  width: 100%;
  transform-origin: 0 50%;
  transform: scaleX(var(--p, 0));
  background: var(--accent);
  pointer-events: none;
}

/* ---------- Command palette ---------- */
.palette__scrim {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: grid;
  place-items: start center;
  padding: clamp(3rem, 10vh, 8rem) 1rem 2rem;
  background: rgba(0, 0, 0, 0.62);
  animation: fadeIn 0.18s var(--ease);
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.palette {
  width: min(620px, 100%);
  border-radius: var(--r-lg);
  border: 1px solid var(--line-strong);
  background: var(--bg-elev);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  animation: paletteIn 0.24s var(--ease);
}
@keyframes paletteIn {
  from { opacity: 0; transform: translateY(-12px) scale(0.98); }
  to { opacity: 1; transform: none; }
}

.palette__field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid var(--line);
}
.palette__field svg { color: var(--accent); flex: none; }
.palette__input {
  flex: 1 1;
  border: 0;
  background: none;
  outline: none;
  font-size: var(--step-1);
  font-family: var(--font-sans);
}
.palette__input::placeholder { color: var(--text-dim); }

.palette__list {
  max-height: min(52vh, 400px);
  overflow-y: auto;
  padding: 0.5rem;
}
.palette__group {
  font-family: var(--font-mono);
  font-size: 0.66rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--text-dim);
  padding: 0.7rem 0.75rem 0.4rem;
}
.palette__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.68rem 0.75rem;
  border-radius: var(--r-md);
  text-align: left;
  color: var(--text-soft);
  transition: background-color 0.15s var(--ease), color 0.15s var(--ease);
}
.palette__item[data-active="true"] {
  background: var(--surface-strong);
  color: var(--text);
}
.palette__item[data-active="true"] .palette__icon {
  color: var(--accent);
  border-color: color-mix(in srgb, var(--accent) 40%, transparent);
}
.palette__icon {
  width: 30px; height: 30px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 9px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--text-dim);
  transition: color 0.15s var(--ease), border-color 0.15s var(--ease);
}
.palette__label { flex: 1 1; font-weight: 500; }
.palette__hint {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: var(--text-dim);
}
.palette__empty {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--text-dim);
  font-family: var(--font-mono);
  font-size: var(--step--1);
}
.palette__foot {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0.7rem 1.1rem;
  border-top: 1px solid var(--line);
  font-size: 0.7rem;
  color: var(--text-dim);
  font-family: var(--font-mono);
}
.palette__foot span { display: inline-flex; align-items: center; gap: 0.35rem; }

/* ---------- Toast ---------- */
.toast {
  position: fixed;
  left: 50%;
  bottom: 28px;
  z-index: 95;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.15rem;
  border-radius: var(--r-md);
  border: 1px solid var(--accent);
  background: var(--bg-elev);
  color: var(--text);
  font-size: var(--step--1);
  font-family: var(--font-mono);
  box-shadow: var(--shadow-md);
  animation: toastIn 0.3s var(--ease);
}
@keyframes toastIn {
  from { opacity: 0; transform: translate(-50%, 14px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE,kCAAkC;AAClC;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;6FAC2F;AAC7F;AACA,aAAa,2BAA2B,EAAE,gCAAgC,EAAE;AAC5E,cAAc,wBAAwB,EAAE;AACxC,WAAW,UAAU,EAAE;;AAEvB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,oBAAoB,gCAAgC,EAAE;AACtD,WAAW,uBAAuB,EAAE,yBAAyB,EAAE;AAC/D,cAAc,WAAW,EAAE;AAC3B,iBAAiB,YAAY,EAAE,oBAAoB,EAAE;;AAErD,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,oGAAoG;AACtG;AACA,cAAc,kBAAkB,EAAE,gCAAgC,EAAE;AACpE,gBAAgB,oBAAoB,EAAE,gEAAgE,EAAE;;AAExG;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,kGAAkG;AACpG;AACA,cAAc,gCAAgC,EAAE;;AAEhD,wEAAwE;AACxE,oBAAoB,iCAAiC,EAAE;;AAEvD;qEACqE;AACrE;EACE,gFAAgF;EAChF,4BAA4B;EAC5B,qEAAqE;AACvE;AACA,oBAAoB,0BAA0B,EAAE;AAChD;EACE,cAAc,eAAe,EAAE;AACjC;;AAEA,cAAc,gDAAgD,EAAE;;AAEhE,8BAA8B;AAC9B;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,4EAA4E;EAC5E,oCAAoC;AACtC;AACA;EACE,0DAA0D;EAC1D,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;AAChD;AACA,4BAA4B,+BAA+B,EAAE;AAC7D,eAAe,eAAe,EAAE;AAChC;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,qEAAqE;AACvE;AACA,mBAAmB,kBAAkB,EAAE,0BAA0B,EAAE;AACnE,kCAAkC,kBAAkB,EAAE;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB;+DAC6D;AAC/D;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,uGAAuG;AACzG;AACA,iBAAiB,kBAAkB,EAAE,gCAAgC,EAAE,gCAAgC,EAAE;;AAEzG;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,eAAe,aAAa,EAAE;;AAE9B;EACE,wBAAwB,aAAa,EAAE;EACvC,eAAe,aAAa,EAAE;AAChC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;AACzB;AACA,qCAAqC,oBAAoB,EAAE;AAC3D,qBAAqB,6BAA6B,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAE/F,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE;AACrD,yBAAyB,kBAAkB,EAAE;;AAE7C,0CAA0C;AAC1C;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,+BAA+B;EAC/B,mCAAmC;AACrC;AACA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;AACtC;AACA,sBAAsB,oBAAoB,EAAE,UAAU,EAAE;AACxD;EACE,SAAO;EACP,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,6BAA6B;AAC/B;AACA,+BAA+B,sBAAsB,EAAE;;AAEvD;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,uEAAuE;AACzE;AACA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gEAAgE;AAClE;AACA;EACE,WAAW,EAAE,YAAY;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,mEAAmE;AACrE;AACA,kBAAkB,SAAO,EAAE,gBAAgB,EAAE;AAC7C;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAE/E,gCAAgC;AAChC;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD","sourcesContent":["/* ------------------------------------------------------------------\n   Reusable pieces: buttons, chips, cards, nav, palette, cursor\n------------------------------------------------------------------- */\n\n/* ---------- Buttons ---------- */\n.btn {\n  --btn-bg: var(--surface-strong);\n  --btn-fg: var(--text);\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  padding: 0.78rem 1.35rem;\n  border-radius: var(--r-md);\n  border: 1px solid var(--line);\n  background: var(--btn-bg);\n  color: var(--btn-fg);\n  font-weight: 600;\n  font-size: var(--step-0);\n  letter-spacing: -0.01em;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  transition: transform 0.24s var(--ease), border-color 0.24s var(--ease),\n    background-color 0.24s var(--ease), box-shadow 0.24s var(--ease), color 0.24s var(--ease);\n}\n.btn:hover { transform: translateY(-2px); border-color: var(--line-strong); }\n.btn:active { transform: translateY(0); }\n.btn svg { flex: none; }\n\n.btn--primary {\n  --btn-bg: var(--accent);\n  --btn-fg: var(--accent-ink);\n  border-color: var(--accent);\n}\n.btn--primary:hover {\n  --btn-bg: var(--accent-hover);\n  border-color: var(--accent-hover);\n}\n\n.btn--ghost:hover { background: var(--surface-hover); }\n.btn--sm { padding: 0.5rem 0.95rem; font-size: var(--step--1); }\n.btn--block { width: 100%; }\n.btn[disabled] { opacity: 0.5; pointer-events: none; }\n\n/* ---------- Chips / tags ---------- */\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.42rem;\n  padding: 0.28rem 0.62rem;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-soft);\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  transition: color 0.2s var(--ease), border-color 0.2s var(--ease), background-color 0.2s var(--ease);\n}\n.chip:hover { color: var(--text); border-color: var(--line-strong); }\n.chip--accent { color: var(--accent); border-color: color-mix(in srgb, var(--accent) 35%, transparent); }\n\n.chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n/* ---------- Card ---------- */\n.card {\n  position: relative;\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  background: var(--surface);\n  overflow: hidden;\n  transition: border-color 0.3s var(--ease), transform 0.3s var(--ease), box-shadow 0.3s var(--ease);\n}\n.card:hover { border-color: var(--line-strong); }\n\n/* Pointer-tracked spotlight. Position comes from CSS vars set on rAF. */\n.card--spot:hover { background: var(--surface-strong); }\n\n/* Tilt toward the pointer. The parent supplies the perspective so the\n   transform stays a single composited property on the card itself. */\n.card--tilt {\n  transform: perspective(1100px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg));\n  transform-style: preserve-3d;\n  transition: transform 0.5s var(--ease), border-color 0.3s var(--ease);\n}\n.card--tilt:hover { transition-duration: 0.12s; }\n@media (prefers-reduced-motion: reduce), (hover: none) {\n  .card--tilt { transform: none; }\n}\n\n.card__body { padding: clamp(1.15rem, 0.9rem + 0.8vw, 1.75rem); }\n\n/* ---------- Nav ---------- */\n.nav {\n  position: fixed;\n  inset: 0 0 auto 0;\n  z-index: 60;\n  height: var(--nav-h);\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s var(--ease), border-color 0.3s var(--ease);\n  border-bottom: 1px solid transparent;\n}\n.nav[data-stuck=\"true\"] {\n  background: color-mix(in srgb, var(--bg) 88%, transparent);\n  border-bottom-color: var(--line);\n}\n.nav__inner {\n  width: 100%;\n  max-width: var(--maxw);\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin-right: auto;\n}\n.brand__mark {\n  width: 34px; height: 34px;\n  border-radius: var(--r-sm);\n  display: grid;\n  place-items: center;\n  background: var(--accent);\n  color: var(--accent-ink);\n  font-family: var(--font-mono);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  transition: background-color 0.25s var(--ease);\n}\n.brand:hover .brand__mark { background: var(--accent-hover); }\n.brand__text { font-size: 1rem; }\n.brand__text small {\n  display: block;\n  font-family: var(--font-mono);\n  font-size: 0.62rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  font-weight: 500;\n}\n\n.nav__links {\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n}\n.nav__link {\n  position: relative;\n  padding: 0.5rem 0.85rem;\n  border-radius: var(--r-pill);\n  font-size: var(--step--1);\n  font-weight: 500;\n  color: var(--text-soft);\n  transition: color 0.2s var(--ease), background-color 0.2s var(--ease);\n}\n.nav__link:hover { color: var(--text); background: var(--surface); }\n.nav__link[aria-current=\"page\"] { color: var(--text); }\n.nav__link[aria-current=\"page\"]::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 2px;\n  width: 16px;\n  height: 2px;\n  transform: translateX(-50%);\n  background: var(--accent);\n}\n\n.nav__tools {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.icon-btn {\n  width: 38px; height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--text-soft);\n  transition: color 0.22s var(--ease), background-color 0.22s var(--ease),\n    border-color 0.22s var(--ease), transform 0.22s var(--ease);\n}\n.icon-btn:hover {\n  color: var(--text);\n  background: var(--surface-hover);\n  border-color: var(--line-strong);\n  transform: translateY(-2px);\n}\n\n.kbd-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  height: 38px;\n  padding-inline: 0.7rem;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--text-dim);\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  transition: color 0.22s var(--ease), border-color 0.22s var(--ease), background-color 0.22s var(--ease);\n}\n.kbd-btn:hover { color: var(--text); border-color: var(--line-strong); background: var(--surface-hover); }\n\nkbd {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  padding: 0.12rem 0.36rem;\n  border-radius: 5px;\n  border: 1px solid var(--line-strong);\n  background: var(--surface-strong);\n  color: var(--text-soft);\n  line-height: 1.5;\n}\n\n.nav__burger { display: none; }\n\n@media (max-width: 900px) {\n  .nav__links, .kbd-btn { display: none; }\n  .nav__burger { display: grid; }\n}\n\n/* Mobile drawer */\n.drawer {\n  position: fixed;\n  inset: var(--nav-h) 0 0 0;\n  z-index: 55;\n  background: var(--bg);\n  padding: 1.6rem var(--gutter) 2.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  animation: drawerIn 0.32s var(--ease);\n  overflow-y: auto;\n}\n@keyframes drawerIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: none; }\n}\n.drawer__link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0.25rem;\n  font-size: var(--step-2);\n  font-weight: 600;\n  border-bottom: 1px solid var(--line);\n  color: var(--text-soft);\n}\n.drawer__link[aria-current=\"page\"] { color: var(--accent); }\n.drawer__link span { font-family: var(--font-mono); font-size: 0.7rem; color: var(--text-dim); }\n\n.drawer__foot { margin-top: auto; padding-top: 2rem; }\n.drawer__foot .socials { margin-top: 0.7rem; }\n\n/* ---------- Scroll progress ---------- */\n.progress {\n  position: fixed;\n  top: 0; left: 0;\n  z-index: 70;\n  height: 2px;\n  width: 100%;\n  transform-origin: 0 50%;\n  transform: scaleX(var(--p, 0));\n  background: var(--accent);\n  pointer-events: none;\n}\n\n/* ---------- Command palette ---------- */\n.palette__scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n  display: grid;\n  place-items: start center;\n  padding: clamp(3rem, 10vh, 8rem) 1rem 2rem;\n  background: rgba(0, 0, 0, 0.62);\n  animation: fadeIn 0.18s var(--ease);\n}\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n.palette {\n  width: min(620px, 100%);\n  border-radius: var(--r-lg);\n  border: 1px solid var(--line-strong);\n  background: var(--bg-elev);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  animation: paletteIn 0.24s var(--ease);\n}\n@keyframes paletteIn {\n  from { opacity: 0; transform: translateY(-12px) scale(0.98); }\n  to { opacity: 1; transform: none; }\n}\n\n.palette__field {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.1rem;\n  border-bottom: 1px solid var(--line);\n}\n.palette__field svg { color: var(--accent); flex: none; }\n.palette__input {\n  flex: 1;\n  border: 0;\n  background: none;\n  outline: none;\n  font-size: var(--step-1);\n  font-family: var(--font-sans);\n}\n.palette__input::placeholder { color: var(--text-dim); }\n\n.palette__list {\n  max-height: min(52vh, 400px);\n  overflow-y: auto;\n  padding: 0.5rem;\n}\n.palette__group {\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  padding: 0.7rem 0.75rem 0.4rem;\n}\n.palette__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.68rem 0.75rem;\n  border-radius: var(--r-md);\n  text-align: left;\n  color: var(--text-soft);\n  transition: background-color 0.15s var(--ease), color 0.15s var(--ease);\n}\n.palette__item[data-active=\"true\"] {\n  background: var(--surface-strong);\n  color: var(--text);\n}\n.palette__item[data-active=\"true\"] .palette__icon {\n  color: var(--accent);\n  border-color: color-mix(in srgb, var(--accent) 40%, transparent);\n}\n.palette__icon {\n  width: 30px; height: 30px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  border-radius: 9px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--text-dim);\n  transition: color 0.15s var(--ease), border-color 0.15s var(--ease);\n}\n.palette__label { flex: 1; font-weight: 500; }\n.palette__hint {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  color: var(--text-dim);\n}\n.palette__empty {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--text-dim);\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n}\n.palette__foot {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 0.7rem 1.1rem;\n  border-top: 1px solid var(--line);\n  font-size: 0.7rem;\n  color: var(--text-dim);\n  font-family: var(--font-mono);\n}\n.palette__foot span { display: inline-flex; align-items: center; gap: 0.35rem; }\n\n/* ---------- Toast ---------- */\n.toast {\n  position: fixed;\n  left: 50%;\n  bottom: 28px;\n  z-index: 95;\n  transform: translateX(-50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.7rem 1.15rem;\n  border-radius: var(--r-md);\n  border: 1px solid var(--accent);\n  background: var(--bg-elev);\n  color: var(--text);\n  font-size: var(--step--1);\n  font-family: var(--font-mono);\n  box-shadow: var(--shadow-md);\n  animation: toastIn 0.3s var(--ease);\n}\n@keyframes toastIn {\n  from { opacity: 0; transform: translate(-50%, 14px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
